import { Sidebar } from "@/components/sidebar";
import { useSidebarData } from "@/packages/features-shared";
import { useParams } from "@tanstack/react-router";

export function AppSidebar() {
  const { workspaceSlug } = useParams({ strict: false });
  const { sidebarProps, isLoading } = useSidebarData(workspaceSlug ?? "");

  if (isLoading) {
    return (
      <aside className="shrink-0 w-[240px] border-r border-border/60 bg-surface animate-pulse" />
    );
  }

  return <Sidebar {...sidebarProps} />;
}
